import { createContext } from 'react';
import { SearchCompaniesOnMapContextProps } from './SearchCompaniesOnMap.types';

export const SearchCompaniesOnMapContext = createContext<SearchCompaniesOnMapContextProps>(
  {} as SearchCompaniesOnMapContextProps
);
